import StatusBar from 'components/StatusBar';
import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { PeriodicReportingType } from '../PeriodicReporting';
import { useLocation } from 'react-router-dom-v5-compat';
import { settleFilteredCheckListAnswers } from 'lib/api_ts/periodicReportingApi';

interface PeriodicReportingSettleModalProps {
	data: PeriodicReportingType;
	fetchData: () => void;
	isModalOpen: boolean;
	setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
	selectedIds: number[];
	invoiceId: string;
	entity: string;
	rc: string[];
}

const PeriodicReportingSettleModal: React.FC<PeriodicReportingSettleModalProps> = ({
	data,
	fetchData,
	isModalOpen,
	setIsModalOpen,
	selectedIds,
	invoiceId,
	entity,
	rc,
}) => {
	const { pathname } = useLocation();
	const projectId = pathname.split('/')[2];
	const blankStatusBar = {
		status: undefined,
		message: '',
		timeout: undefined,
	};

	const [statusBar, setStatusBar] = useState(blankStatusBar);
	const resetStatusBar = () => {
		setStatusBar(blankStatusBar);
	};

	const settleAll = async () => {
		setStatusBar({
			status: 'elaborating',
			message: 'Sanatoria in corso',
			timeout: false,
		});
		try {
			await settleFilteredCheckListAnswers(projectId, data.id, selectedIds, {
				rpCode: invoiceId,
				type: entity,
				rc,
			});
			setStatusBar({
				status: 'success',
				message: 'Periodic Reporting sanato con successo',
				timeout: true,
			});
			setTimeout(() => {
				setIsModalOpen(false);
				resetStatusBar();
				fetchData();
			}, 2000);
		} catch (error) {
			setStatusBar({
				status: 'error',
				message: 'Errore durante la sanatoria del Periodic Reporting',
				timeout: true,
			});
			setTimeout(() => {
				resetStatusBar();
			}, 2000);
		}
	};
	return (
		<>
			<Button
				onClick={() => {
					setIsModalOpen(true);
				}}
				disabled={selectedIds.length === 0}
			>
				Sana le quote selezionate
			</Button>
			<Modal show={isModalOpen} onHide={() => setIsModalOpen(false)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Attenzione</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="my-3">
						<span>Sei sicuro di voler procedere? Gli interventi sanatori non potranno più essere modificati.</span>
					</div>
					{statusBar.status ? (
						<StatusBar status={statusBar.status} message={statusBar.message} timeout={statusBar.timeout}>
							<></>
						</StatusBar>
					) : null}
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={settleAll}>Valida</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default PeriodicReportingSettleModal;
